<template>
    <v-container :class="isMobile? 'pa-0':'pa-2'">
        <v-layout row wrap>
            <v-card flat style="width:100%;" class="mb-2">            
                <table style="width:100%;">
                    <tr>
                        <td colspan="3"><h3>Bill Payment/Transfer</h3></td>
                    </tr>
                    <tr>
                        <td style="width:50px;">Ref 1</td>
                        <td>{{refs[0]}}</td>
                        <td rowspan="2" :style="'color:#000;font-weight:bold;width:300px;text-align:right;font-size:'+(isMobile? 15:20)+'px;vertical-align:bottom;'">Amount to pay: <span style="color:blue;">{{helper.numberFormat.formatPrice(gndTol)}}</span> {{curr}}</td>                        
                    </tr>
                    <tr>
                        <td style="width:50px;">Ref 2</td>
                        <td>{{refs[1]}}</td>
                    </tr>                   
                </table>
            </v-card>
        </v-layout>
        <v-layout row wrap>
            <v-flex md3 v-if="bankAccounts.length==1 && isMobile==false"></v-flex>
            <v-flex md6 pr-1 v-for="(ba,index) in bankAccounts" :key="'b_'+index">
                <BillPaymentBank
                    :bankCode="ba.BankCode"
                    :bankName="ba.BankName"
                    :accountNo="ba.AccountNo"
                    :accountName="getAccountName(ba)"
                    :branch="ba.Branch"
                    :accountType="ba.TypeWording"
                    />
            </v-flex>
        </v-layout>
        
    </v-container>
</template>

<script>
import BillPaymentBank from './BillPaymentBank';
import Helper from '../helper';

export default {
    props:["bankAccounts","refs","grandTotal","currency", "sellingCurrency"],
    components:{
        BillPaymentBank
    },
    created(){
        if (this.grandTotal!=null) {
          this.gndTol = this.grandTotal;
          if (this.sellingCurrency != null){
            this.gndTol = Math.ceil(this.gndTol * this.sellingCurrency.FxRate)
          }
        }
        if (this.currency!=null) {
          this.curr = this.currency;
          if (this.sellingCurrency != null) {
            this.curr = this.sellingCurrency.CurrencyCode
          }
        }
    },
    computed:{
        isMobile(){
            return Helper.display.isMobile(this.$vuetify.breakpoint.name);
        },
    },
    data(){
        return {
            gndTol:0.00,
            curr:"THB",
            helper:Helper,
        }
    },
    methods:{
        getAccountName(account){          
          return account.AccountName==null? account.Name:account.AccountName;
        }
    },
}
</script>

<style>

</style>